module.exports = __webpack_public_path__ + "media/src/images/scene-55e870bf5957c048bd1a642c23506c43.svg";